(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if ((window.location.pathname === '/collections/all' || window.location.pathname === '/pages/shop-by-brand') && !url.searchParams.get('sort_by')) {
    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.toString());
  }
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const removeOcosmedicsHelpParagraphs = (intro) => {
    if (!intro) return;
    Array.from(intro.querySelectorAll('p')).forEach((paragraph) => {
      const text = (paragraph.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (
        text.includes('need help choosing?') ||
        text.includes('shop by skin concern') ||
        text.includes('explore our beauty services')
      ) {
        paragraph.remove();
      }
    });
  };

  const initOcosmedicsQuickLinks = () => {
    const intro = document.querySelector('.collection-intro__description');
    if (!intro) return;

    removeOcosmedicsHelpParagraphs(intro);

    const categoryParagraph = Array.from(intro.querySelectorAll('p')).find(
      (paragraph) => paragraph.textContent.includes('Browse by category:') && paragraph.querySelectorAll('a').length >= 4
    );
    if (categoryParagraph) {
      const links = Array.from(categoryParagraph.querySelectorAll('a'));
      if (links.length) {
        const wrap = document.createElement('div');
        wrap.className = 'o-cosmedics-quick-links';

        const eyebrow = document.createElement('p');
        eyebrow.className = 'o-cosmedics-quick-links__eyebrow';
        eyebrow.textContent = 'Browse by category';
        wrap.appendChild(eyebrow);

        const grid = document.createElement('div');
        grid.className = 'o-cosmedics-quick-links__grid';

        links.forEach((link) => {
          const button = document.createElement('a');
          button.className = 'o-cosmedics-quick-links__pill';
          button.href = link.getAttribute('href') || '#';
          button.textContent = (link.textContent || '').trim();
          grid.appendChild(button);
        });

        wrap.appendChild(grid);
        categoryParagraph.replaceWith(wrap);
      }
    }

    removeOcosmedicsHelpParagraphs(intro);

    const observer = new MutationObserver(() => removeOcosmedicsHelpParagraphs(intro));
    observer.observe(intro, { childList: true, subtree: true });
  };

  if (
    window.location.pathname === '/collections/o-cosmedics' ||
    window.location.pathname === '/collections/o-cosmedics'
  ) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOcosmedicsQuickLinks, { once: true });
    } else {
      initOcosmedicsQuickLinks();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
